import useFeatures from 'hooks/useFeatures';
import { Navigate } from 'react-router-dom';
import ChannelsTabs from './ChannelsTabs';

const Channels = () => {
  const { allowChannelsV3 } = useFeatures();

  if (!allowChannelsV3) {
    return <Navigate to="/channels-migrated" />;
  }

  return (
    <div className="container">
      <ChannelsTabs />
    </div>
  );
};

export default Channels;
